import React from "react";
import "./faq.css";
import faqimg from "../../images/FAQ/faq.svg";
import { Link } from "react-router-dom";

function FAQ() {
  return (
    <div className="container">
      <p
        className="container_heading"
        style={{ textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      >
        <span className="heading_first" style={{ border: "none" }}>
          FAQ
        </span>
        s
      </p>

      <div className="faq_container">
        <div className="faq_text_cont">
          <p className="faq_text">
            Get all your general queries solved regarding Event Management and
            about us and our services. We have listed very common questions that
            our clients must know before availing our services so that you can
            trust us more and Enjoy your event after getting carefree.{" "}
          </p>

          <Link style={{ textDecoration: "none" }} to={"/faqs"}>
            <button className="faqs_btn">KNOW MORE</button>
          </Link>
        </div>

        <img src={faqimg} className="faq_image" />
      </div>
    </div>
  );
}

export default FAQ;
